/** Path do Route dos Clientes */
export const CLIENTES_PATH_ROUTE = 'clientes';
